import { visitListItem } from "../theme/default/visit-list-item";

export const buildVisitList = visits => {
  return visits.map(visit => {
    const {
      request_date,
      member_first_name,
      memberLastName,
      providerFirstName,
      providerLastName,
      specialty_name,
      diagnosis_name,
      rxPrescribed,
      excuseNotePresent,
      runAction
    } = visit;
    const date = new Date(request_date);
    const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date
      .getFullYear()
      .toString()
      .slice(-2)}`;
    const data = {
      childrenData: {
        childrenList: visitListItem({ ...visit, formattedDate })
      },
      key: "selectedData",
      type: "listItemWrapper",
      title: "",
      selectedData: {
        consult_date: formattedDate,
        consult_patient: `${member_first_name} ${memberLastName}`,
        consult_doctor: `${providerFirstName} ${providerLastName}`,
        consult_specialty: specialty_name,
        consult_diagnosis: diagnosis_name,
        consult_rx: rxPrescribed,
        hasExcuse: excuseNotePresent
      },
      renderFields: true,
      childrenType: "visit-list-item"
    };

    if (runAction) {
      const { consult_id: consultation_id, message_room_id } = runAction.data;

      data.action = {
        ...runAction,
        data: { consultation_id, message_room_id }
      };
    }

    return data;
  });
};
